import { styled } from '@gogovan/entier-web-core/ext/mui/styles';
import { Select } from '@gogovan/entier-web-core/ext/mui/Select';

const RegionLanSelectRow = styled('div')`
  display: flex;
  align-items: center;
  opacity: 85%;
`;

const CustomSelector = styled(Select)`
  .MuiSelect-select {
    padding-right: 4px !important;
    margin-right: 20px;
    margin-left: -34px;
    padding-left: 34px;
  }
`;

export { CustomSelector, RegionLanSelectRow };
